import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

export const useInflowOutflow = (userId, year) => {
  const { data: inflowOutflowData, ...queryResponse } = useQuery({
    queryKey: ["inflow-outflow", userId, year],
    queryFn: () => api.opekepe.fetchInflowOutflowData(userId, year, "json"),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { inflowOutflowData, fetchState };
};

export const useDownloadInflowOutflow = (userId, year) => {
  const { mutateAsync, ...queryResponse } = useMutation({
    mutationKey: ["download-inflow-outflow", userId, year],
    mutationFn: (fileType) =>
      api.opekepe.fetchInflowOutflowData(userId, year, fileType),
  });

  const downloadReport = async (fileType) => {
    const data = await mutateAsync(fileType);

    const blob = new Blob([data.data], {
      type: data.contentType,
    });

    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = data.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(objectUrl);
  };

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { downloadReport, fetchState };
};
